<div class="flex-fill d-flex flex-column">
    <div class="row m-1">
        <div class="col-sm-1 ms-10">
            <div class="dx-field-label" style="overflow: unset; text-overflow: unset">Select Statuses</div>
        </div>
        <div class="col-sm-3 ms-10">
            <dx-tag-box [items]="statusList" [(value)]="selectedStatuses" [showSelectionControls]="true" displayExpr="name" valueExpr="id"></dx-tag-box>
        </div>
        <div class="col-sm-2 ps-0">
            <button type="button" [hidden]="false" (click)="searchByStatus()" class="btn btn-success">Search</button>
        </div>
    </div>
    <div class="m-1 grid-fill" *ngIf="models">
        <dx-data-grid
            #dataGrid
            [dataSource]="models"
            [columnAutoWidth]="false"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            (onOptionChanged)="onOptionChanged($event)"
            (onContentReady)="onContentReady($event)"
            (onExporting)="onExporting($event)"
        >
            <dxi-column dataField="partNumber" caption="Part #" width="200"></dxi-column>
            <dxi-column dataField="partCount" caption="Count" width="80"></dxi-column>
            <dxi-column dataField="status" caption="Status" width="200"></dxi-column>

            <dxo-remote-operations [sorting]="true" [paging]="true" [filtering]="true"></dxo-remote-operations>
            <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
            <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <!-- <dxo-state-storing [enabled]="true" type="localStorage" storageKey="purchase-order-search-grid"></dxo-state-storing> -->
            <dxo-selection [mode]="'multiple'"></dxo-selection>

            <div *dxTemplate="let data of 'toolbarButtons'"></div>
            <div *dxTemplate="let data of 'toolbarText'">
                <span *ngIf="models" class="me-3"
                    ><strong>{{ dataGrid.instance.totalCount() + ' items' }}</strong></span
                >
            </div>
        </dx-data-grid>
    </div>
</div>
